module.exports = __webpack_public_path__ + "img/RECREATION_SPEEDQUIZ.74129631.png";